export interface EventMessage {
  id?: string;
  event?: string;
  data?: string;
  retry?: number;
  comment?: string;
}

function sseKeyValueLineSplit(line: string) {
  const position = line.indexOf(":");

  if (position === -1) {
    return { key: line };
  }

  const key = line.substring(0, position);
  const value = position < line.length ? line.substring(position + 1) : "";

  return { key, value };
}

function sseParseMessaage(lines: string[]) {
  const message: EventMessage = {};
  while (lines.length) {
    const line = lines.shift();
    if (!line) {
      break;
    }
    const { key, value } = sseKeyValueLineSplit(line);
    if (key === "\n" || value === undefined) {
      break;
    } else if (key === "id") {
      message.id = value;
    } else if (key === "retry") {
      const retry = parseInt(value, 10);
      if (!isNaN(retry)) {
        message.retry = retry;
      }
    } else if (key === "event") {
      message.event = value;
    } else if (key === "data") {
      message.data = value;
    } else if (key === "comment") {
      message.comment = value;
    } else {
      console.info(`SseNotifications: Unknown line in message: ${line}`);
    }
  }

  if (
    message.id ||
    message.retry ||
    message.event ||
    message.data ||
    message.comment
  ) {
    return message;
  } else {
    return null;
  }
}

export function sseParseMessages(value: string) {
  const messages: EventMessage[] = [];
  const lines = value.split("\n");
  while (lines.length) {
    const message = sseParseMessaage(lines);
    if (message) {
      messages.push(message);
    }
  }
  return messages;
}
